
  import * as awsAmplifyRuntime$dqgUWIffbunvconth1wbwiE9dLrDzte_45DRPDsIrBNDk from '/codebuild/output/src3507326296/src/luckywise/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.8.2_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [
    "d1p54ao86z4jzg.cloudfront.net"
  ],
  "alias": {
    "/cdn": "https://d1p54ao86z4jzg.cloudfront.net"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['awsAmplify']: { provider: awsAmplifyRuntime$dqgUWIffbunvconth1wbwiE9dLrDzte_45DRPDsIrBNDk, defaults: {} }
    }
  }
